import VendorReceiveContainer from '@components/containers/vendorReceive';
import VendorLayout from '@layouts/VendorLayout';
import { type FC } from 'react';

const VendorReceive: FC = () => (
    <VendorLayout>
        <VendorReceiveContainer />
    </VendorLayout>
);

export default VendorReceive;
